import { styled, Input } from '@mui/material';

export const StyledNumberInput = styled(Input)`
  width: 40px;
  border-radius: 6px;

  &:before {
    border: none !important;
    width: 40px;
    text-align: center;
    border: none;
    padding: 8px 10px;
    font-size: 16px;
    outline: none;
    &:active,
    &:hover,
    &:focus {
      border: none !important;
    }
  }

  &:after {
    border: none !important;

    &:active,
    &:hover,
    &:focus {
      border: none !important;
    }
  }

  input {
    text-align: center !important;
    padding: 0 4px !important;
  }
`;
